import { ReactElement } from 'react'
import { useSteps } from '../../../../contexts/stepContext'
import FrequencyTemplate from './template'
import {
    CompanyActions,
    CompanyLeadState,
} from '@raskrask-dk/bookingflow-state-machine'
import { useBFSMValue } from '../../../../services/hooks/useBFSMValues'
import { CompanyLeadFrequency } from '@raskrask-dk/raskrask-utils'

const FrequencyPage = (): ReactElement => {
    const [currentStep, helpers] = useSteps()

    const [companySettings, setCompanySettings] = useBFSMValue<
        CompanyLeadState,
        CompanyActions.SetCompanySettings,
        'companySettings'
    >('companySettings', CompanyActions.SetCompanySettings)

    const onClickFrequency = (option: CompanyLeadFrequency) =>
        setCompanySettings({
            ...companySettings,
            frequency:
                companySettings && option !== companySettings.frequency
                    ? option
                    : undefined,
        })

    return (
        <FrequencyTemplate
            frequency={companySettings?.frequency}
            currentStep={currentStep}
            onClickFrequency={onClickFrequency}
            helpers={helpers}
        />
    )
}

export default FrequencyPage
